import { Form } from 'components';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

const FilterItemRole = ({ roles = [], name, defaultValue, label = 'Role', layout }) => (
  <Form.Row layout={layout}>
    <Form.Select
      name={name}
      data-cy={name}
      title={label}
      type="radio"
      label={label}
      defaultValue={defaultValue}
      enableClear
    >
      <Form.Select.Item value="" label="All Roles" isDefault />
      {roles.map(role => (
        <Form.Select.Item key={role.id} value={role.name} label={role.name} />
      ))}
    </Form.Select>
  </Form.Row>
);

FilterItemRole.propTypes = {
  label: PropTypes.string,
  roles: PropTypes.array,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string
};

const mapStateToProps = state => ({
  roles: state.roles.data.permission_roles
});

export default connect(mapStateToProps, null, null, { pure: false })(FilterItemRole);
